import React, {useEffect} from "react";
import {useAtom} from "jotai";
import {
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import {MintBanner} from "../banner/MintBanner";
import {PhantomWalletModalAtom} from "../../atoms";

export const PhantomWalletDialogModal = () => {
  const [dialog, setDialog] = useAtom(PhantomWalletModalAtom);

  const handleClose = () => {
    setDialog((prev) => ({...prev, open: false}));
  };

  const handleConfirm = (addr) => {
    if (addr) {
      console.log("CONFIRM", addr);
      dialog.resolve(addr); // Resolve the promise with true
      handleClose();
    }
  };

  const handleCancel = () => {
    dialog.resolve(null); // Resolve the promise with false
    handleClose();
  };

  return (
    <Dialog
      open={dialog.open} onClose={handleCancel}
      fullWidth maxWidth="xs"
      PaperProps={{
        sx: {
          borderRadius: 5,
          p: 0,
          backgroundColor: "#fff", // Customize background
          boxShadow: 6,            // Stronger shadow
        },
      }}
    >
      {/*<DialogTitle sx={{fontSize: "1.3rem"}}>{dialog.title}</DialogTitle>*/}
      <DialogContent>
        <DialogContentText>
          <MintBanner setAccount={handleConfirm}/>
        </DialogContentText>
      </DialogContent>
    </Dialog>
  );
};
